<div class="card-container">
  <div class="hero-container">
    <div
      class="hero"
      [style.background-image]='backgroundImage'
      [class]="petType === 1 ? 'image-position-dog' : 'image-position-cat'"
    >
      <div class="hero-overlay"></div>
      <div class="hero-content d-flex">
        <div class="container d-flex flex-row">
          <div class="hero-content-text align-self-center">
            <img
              *ngIf="!hideIcon"
              class="hero-image"
              src="assets/images/main-plan-card/alertID.svg"
              alt="alert-and-id"
            />
            <h1>identialert</h1>
            <h5 [innerHTML]="subtitleText"></h5>
          </div>
        </div>
        <div class="splodge-container">
          <img
            class="image"
            src="assets/images/main-plan-card/orange-splodge.png"
            alt="orange-splodge"
          />
          <p class="text-join_over" *ngIf="thereIsOnlyOneCat">Join over <br> 80,000 <br> members!</p>
          <p class="text" *ngIf="!thereIsOnlyOneCat">Trusted by 80,000+ pet keepers</p>
        </div>
      </div>
    </div>
  </div>
  <div class="content-container">
    <div class="included-list">
      <ul class="image-text-list">
        <li *ngFor="let con of content" class="list-item">
          <img [src]="con.imgSrc" alt="rand" class="list-image" />
          <p>{{ con.text }}</p>
        </li>
      </ul>
    </div>
    <div class="pricing-container">
      <ul class="price-list">
        <li>£36 per year</li>
        <li>OR</li>
        <li>£4.99 per month</li>
        <li>(12 month contract)</li>
      </ul>
      <button
        class="btn w-100 btn-secondary text-white btn-lg btn-buy-now"
        type="button"
        (click)="buyIdentiAlertSubscription()"
        [disabled]="disabledBuyNow"
      >
      Buy now
      </button>
      <button
        class="btn btn-outline-dark btn-lg btn-learn-more mt-2"
        type="button"
        routerLink="/identialert"
      >
        Learn More
      </button>
    </div>
  </div>
</div>
